import { CAlert, CBadge, CButton, CButtonGroup, CCol, CDropdown, CDropdownDivider, CDropdownItem, CDropdownMenu, CDropdownToggle, CFormInput, CFormLabel, CInputGroup, CModal, CModalBody, CModalHeader, CModalTitle, CRow, CSpinner } from "@coreui/bootstrap-react"
import { useEffect, useState } from "react";

import CIcon from '@coreui/icons-react';
import * as icon from '@coreui/icons';

import { CWidgetStatsF } from '@coreui/react'
import { useDispatch, useSelector } from "react-redux";
import { Nav, Toast } from "react-bootstrap";
import DashboardsService from "../store/dashboards/service";
import { toast } from "react-hot-toast";

const Analysis = ({ data }) => {
    const [visible, setVisible] = useState(false)
    const [price, setPrice] = useState(data.price_24h)
    const [lowPrice, setLowPrice] = useState(data?.analysis?.low_price)
    const [lowDetails, setLowDetails] = useState(data?.analysis?.low_details)
    const [highPrice, setHighPrice] = useState(data?.analysis?.high_price)
    const [highDetails, setHighDetails] = useState(data?.analysis?.high_details)

    const handelAnalysis = () => {
        DashboardsService.analysis({ id: data.id, price: price, low_price: lowPrice, high_price: highPrice, high_details: highDetails, low_details: lowDetails });
        toast.success('آیتم های انتخاب شده با موفقیت منتقل گردید.')
    }

    return (
        <>
            <br />
            <CModal size="xl" visible={visible} onClose={() => setVisible(false)}>
                <CModalHeader>
                    <CModalTitle>تحلیل توکن</CModalTitle>
                    {data?.analysis &&
                        <CBadge color="success" className='m-1'>
                            درحال حاضر آنالیز این ارز فعال می باشد.
                        </CBadge>

                    }
                    {!data?.analysis &&
                        <CBadge color="warning" className='m-1'>
                            درحال حاضر آنالیز این ارز فعال نمی باشد.
                        </CBadge>
                    }
                </CModalHeader>
                <CModalBody>
                    <CRow>

                        <CRow className="mb-3">
                            <CFormLabel htmlFor="price" className="col-sm-2 col-form-label">قیمت فعلی</CFormLabel>
                            <CCol sm={10}>
                                <CFormInput type="number" id="price" value={price} onChange={(e) => (setPrice(parseFloat(e.target.value)))} />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CFormLabel htmlFor="low_price" className="col-sm-2 col-form-label">قیمت کف</CFormLabel>
                            <CCol sm={10}>
                                <CFormInput type="number" id="low_price" value={lowPrice} onChange={(e) => (setLowPrice(parseFloat(e.target.value)))} />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CFormLabel htmlFor="high_price" className="col-sm-2 col-form-label">قیمت سقف</CFormLabel>
                            <CCol sm={10}>
                                <CFormInput type="number" id="high_price" value={highPrice} onChange={(e) => (setHighPrice(parseFloat(e.target.value)))} />
                            </CCol>
                        </CRow>
                        
                        <CRow className="mb-3">
                            <CFormLabel htmlFor="low_details" className="col-sm-2 col-form-label">توضیحات کف</CFormLabel>
                            <CCol sm={10}>
                                <CFormInput type="text" id="low_details" placeholder="توضیحات درباره قیمت کف می توانید وارد کنید ..." value={lowDetails} onChange={(e) => (setLowDetails(e.target.value))} />
                            </CCol>
                        </CRow>
                        <CRow className="mb-3">
                            <CFormLabel htmlFor="high_details" className="col-sm-2 col-form-label">توضیحات سقف</CFormLabel>
                            <CCol sm={10}>
                                <CFormInput type="text" id="high_details" placeholder="توضیحات درباره قیمت سقف می توانید وارد کنید ..." value={highDetails} onChange={(e) => (setHighDetails(e.target.value))} />
                            </CCol>
                        </CRow>
                        <CCol xs="auto">
                            <CButton type="submit" className="mb-3" onClick={() => (handelAnalysis())}>
                                تایید و فعال سازی
                            </CButton>
                        </CCol>
                    </CRow>
                </CModalBody>
            </CModal>
            <CButton color="primary" className="position-relative" onClick={() => setVisible(!visible)}>
                تحلیل توکن
                <CBadge
                    className="border border-light p-2"
                    color={data?.analysis ? "success" : "danger"}
                    position="top-end"
                    shape="rounded-circle"
                >
                    <span className="visually-hidden">New alerts</span>
                </CBadge>
            </CButton>
        </>


    )
}

export default Analysis;